<template>
  <div v-if="isVisible" class="floating-window"
    :style="{ top: windowY + 'px', left: windowX + 'px', width: windowWidth + 'px', height: windowHeight + 'px' }">
    <div class="resize-handle top" @mousedown="startResize('top', $event)"></div>
    <div class="resize-handle right" @mousedown="startResize('right', $event)"></div>
    <div class="resize-handle bottom" @mousedown="startResize('bottom', $event)"></div>
    <div class="resize-handle left" @mousedown="startResize('left', $event)"></div>

    <div class="resize-handle top-left" @mousedown="startResize('top-left', $event)"></div>
    <div class="resize-handle top-right" @mousedown="startResize('top-right', $event)"></div>
    <div class="resize-handle bottom-left" @mousedown="startResize('bottom-left', $event)"></div>
    <div class="resize-handle bottom-right" @mousedown="startResize('bottom-right', $event)"></div>

    <div class="window-header" @mousedown="startDrag">
      <span>収集状況</span>
    </div>

    <div class="table-scroll-container">
      <div v-if="isUpdating" class="loading-overlay">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <b-table-simple class="text-center" small no-border-collapse bordered>
        <b-thead>
          <b-tr variant="success">
            <b-th rowspan="2" class="align-middle">種別</b-th>
            <b-th rowspan="2" class="align-middle">地区</b-th>
            <b-th rowspan="2" class="align-middle">収集数</b-th>
            <b-th rowspan="2" class="align-middle">収集エリア</b-th>
            <b-th rowspan="2" class="align-middle">収集車両</b-th>
            <b-th colspan="2" class="align-middle">収集率</b-th>
          </b-tr>
          <b-tr variant="success">
            <b-th class="align-middle">地区</b-th>
            <b-th class="align-middle">全体</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(district, index) in tableData.combustibleData" :key="'combustible-' + index">
            <b-td class="align-middle" v-if="index === 0" :rowspan="tableData.combustibleData.length">
              可燃ゴミ
            </b-td>
            <b-td class="align-middle">{{ district.districtName }}</b-td>
            <b-td class="align-middle">{{ `${district.collectedCount}/${district.totalCount}` }}</b-td>
            <b-td class="align-middle">{{ district.areaList.join(', ') }}</b-td>
            <b-td class="align-middle max-width">{{ district.carNumberList.join(', ') }}</b-td>
            <b-td class="align-middle">{{ district.districtCollectionRates }}%</b-td>
            <b-td class="align-middle" v-if="index === 0"
              :rowspan="tableData.combustibleData.length + tableData.nonCombustibleData.length">
              {{ tableData.overallCollectionRate }}%
            </b-td>
          </b-tr>
          <b-tr v-for="(district, index) in tableData.nonCombustibleData" :key="'nonCombustible-' + index">
            <b-td class="align-middle" v-if="index === 0" :rowspan="tableData.nonCombustibleData.length">
              不燃ゴミ
            </b-td>
            <b-td class="align-middle">{{ district.districtName }}</b-td>
            <b-td class="align-middle">{{ `${district.collectedCount}/${district.totalCount}` }}</b-td>
            <b-td class="align-middle">{{ district.areaList.join(', ') }}</b-td>
            <b-td class="align-middle max-width">{{ district.carNumberList.join(', ') }}</b-td>
            <b-td class="align-middle">{{ district.districtCollectionRates }}%</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <div class="window-footer">
      <b-button variant="primary" @click="updateData">更新</b-button>
      <b-button variant="secondary" @click="closeWindow">閉じる</b-button>
    </div>
  </div>
</template>

<script>
import { BTableSimple, BThead, BTr, BTh, BTbody, BTd, BSpinner } from 'bootstrap-vue-next';

export default {
  components: {
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTbody,
    BTd,
    BSpinner
  },
  props: {
    apiData: {
      type: Object,
      required: true
    },
    isUpdating: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      tableData: {
        combustibleData: [],
        nonCombustibleData: [],
        overallCollectionRate: 0
      },
      updateInterval: null,
      isVisible: false,
      isDragging: false,
      isResizing: false,
      resizeDirection: '',
      dragStartX: 0,
      dragStartY: 0,
      initialWindowX: 0,
      initialWindowY: 0,
      initialWindowWidth: 0,
      initialWindowHeight: 0,
      windowX: 0,
      windowY: 0,
      windowWidth: 600,
      windowHeight: 400
    };
  },
  beforeUnmount() {
    console.log('CollectionProgressModal component is being destroyed');
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
  created() {
  },
  methods: {
    fetchData() {
      this.tableData = this.apiData;
    },
    showWindow() {
      this.isVisible = true;
      this.fetchData();
      this.$nextTick(() => {
        this.centerWindow();
      });

      // インターバルを設定して1分ごとにデータを更新
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 60000); // 60000ミリ秒 = 1分
    },
    closeWindow() {
      this.isVisible = false;
      this.$emit('close-window');

      // インターバルをクリア
      if (this.updateInterval) {
        clearInterval(this.updateInterval);
        this.updateInterval = null;
      }
    },
    updateData() {
      this.$emit('update-data');
    },
    centerWindow() {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      this.windowX = (viewportWidth - this.windowWidth) / 2;
      this.windowY = (viewportHeight - this.windowHeight) / 2;

      if (this.windowX < 0) this.windowX = 0;
      if (this.windowY < 0) this.windowY = 0;
    },
    startDrag(event) {
      if (event.target.closest('.window-header')) {
        event.preventDefault();
        this.isDragging = true;
        this.dragStartX = event.clientX - this.windowX;
        this.dragStartY = event.clientY - this.windowY;
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('mouseup', this.stopDrag);
      }
    },
    onDrag(event) {
      if (this.isDragging) {
        let newX = event.clientX - this.dragStartX;
        let newY = event.clientY - this.dragStartY;

        const windowWidth = this.$el.offsetWidth;
        const windowHeight = this.$el.offsetHeight;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        if (newX < 0) {
          newX = 0;
        } else if (newX + windowWidth > viewportWidth) {
          newX = viewportWidth - windowWidth;
        }

        if (newY < 0) {
          newY = 0;
        } else if (newY + windowHeight > viewportHeight) {
          newY = viewportHeight - windowHeight;
        }

        this.windowX = newX;
        this.windowY = newY;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    startResize(direction, event) {
      event.preventDefault();
      this.isResizing = true;
      this.resizeDirection = direction;
      // リサイズ開始時のマウス位置を保存 (ここが重要)
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      // リサイズ開始時のウィンドウの状態を保存
      this.initialWindowX = this.windowX;
      this.initialWindowY = this.windowY;
      this.initialWindowWidth = this.windowWidth;
      this.initialWindowHeight = this.windowHeight;
      document.addEventListener('mousemove', this.onResize);
      document.addEventListener('mouseup', this.stopResize);
    },
    onResize(event) {
      if (this.isResizing) {
        // マウスの初期位置からの総移動量を計算
        const deltaX = event.clientX - this.dragStartX;
        const deltaY = event.clientY - this.dragStartY;

        const minWidth = 200;
        const minHeight = 150;

        let newX = this.initialWindowX; // 初期X位置を基準に計算
        let newY = this.initialWindowY; // 初期Y位置を基準に計算
        let newWidth = this.initialWindowWidth; // 初期幅を基準に計算
        let newHeight = this.initialWindowHeight; // 初期高さを基準に計算

        switch (this.resizeDirection) {
          case 'top':
            newHeight = Math.max(minHeight, this.initialWindowHeight - deltaY);
            newY = this.initialWindowY + (this.initialWindowHeight - newHeight); // 新しい高さに基づいてY位置を調整
            break;
          case 'right':
            newWidth = Math.max(minWidth, this.initialWindowWidth + deltaX);
            break;
          case 'bottom':
            newHeight = Math.max(minHeight, this.initialWindowHeight + deltaY);
            break;
          case 'left':
            newWidth = Math.max(minWidth, this.initialWindowWidth - deltaX);
            newX = this.initialWindowX + (this.initialWindowWidth - newWidth); // 新しい幅に基づいてX位置を調整
            break;
          case 'top-left':
            newWidth = Math.max(minWidth, this.initialWindowWidth - deltaX);
            newX = this.initialWindowX + (this.initialWindowWidth - newWidth);
            newHeight = Math.max(minHeight, this.initialWindowHeight - deltaY);
            newY = this.initialWindowY + (this.initialWindowHeight - newHeight);
            break;
          case 'top-right':
            newWidth = Math.max(minWidth, this.initialWindowWidth + deltaX);
            newHeight = Math.max(minHeight, this.initialWindowHeight - deltaY);
            newY = this.initialWindowY + (this.initialWindowHeight - newHeight);
            break;
          case 'bottom-left':
            newWidth = Math.max(minWidth, this.initialWindowWidth - deltaX);
            newX = this.initialWindowX + (this.initialWindowWidth - newWidth);
            newHeight = Math.max(minHeight, this.initialWindowHeight + deltaY);
            break;
          case 'bottom-right':
            newWidth = Math.max(minWidth, this.initialWindowWidth + deltaX);
            newHeight = Math.max(minHeight, this.initialWindowHeight + deltaY);
            break;
        }

        // 最終的な境界チェックと適用
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // X座標と幅の調整
        if (newX < 0) {
          newWidth += newX; // はみ出した分だけ幅を広げる（または縮める）
          newX = 0;
        }
        if (newX + newWidth > viewportWidth) {
          newWidth = viewportWidth - newX;
        }
        if (newWidth < minWidth) {
          newWidth = minWidth;
          // X位置を調整する場合は、対応する辺からのリサイズのみ
          if (this.resizeDirection.includes('left')) {
            newX = this.initialWindowX + (this.initialWindowWidth - minWidth);
          }
        }
        this.windowX = newX;
        this.windowWidth = newWidth;

        // Y座標と高さの調整
        if (newY < 0) {
          newHeight += newY; // はみ出した分だけ高さを広げる（または縮める）
          newY = 0;
        }
        if (newY + newHeight > viewportHeight) {
          newHeight = viewportHeight - newY;
        }
        if (newHeight < minHeight) {
          newHeight = minHeight;
          // Y位置を調整する場合は、対応する辺からのリサイズのみ
          if (this.resizeDirection.includes('top')) {
            newY = this.initialWindowY + (this.initialWindowHeight - minHeight);
          }
        }
        this.windowY = newY;
        this.windowHeight = newHeight;
      }
    },
    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.onResize);
      document.removeEventListener('mouseup', this.stopResize);
    }
  },
  watch: {
    apiData: {
      handler(newData) {
        this.tableData = newData;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.floating-window {
  position: fixed;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.resize-handle {
  position: absolute;
  background-color: transparent;
  z-index: 10001;
}

/* 辺のリサイズハンドル */
.resize-handle.top {
  top: 0;
  left: 5px;
  right: 5px;
  height: 5px;
  cursor: ns-resize;
}

.resize-handle.right {
  top: 5px;
  right: 0;
  bottom: 5px;
  width: 5px;
  cursor: ew-resize;
}

.resize-handle.bottom {
  left: 5px;
  right: 5px;
  bottom: 0;
  height: 5px;
  cursor: ns-resize;
}

.resize-handle.left {
  top: 5px;
  left: 0;
  bottom: 5px;
  width: 5px;
  cursor: ew-resize;
}

/* 角のリサイズハンドル */
.resize-handle.top-left {
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  cursor: nwse-resize;
}

.resize-handle.top-right {
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  cursor: nesw-resize;
}

.resize-handle.bottom-left {
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  cursor: nesw-resize;
}

.resize-handle.bottom-right {
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  cursor: nwse-resize;
}

.window-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
  cursor: move;
  flex-shrink: 0;
}

.table-scroll-container {
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
}

.window-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background-color: #f5f5f5;
  border-top: 1px solid #ccc;
  flex-shrink: 0;
}

.align-middle {
  vertical-align: middle;
}

.max-width {
  max-width: 150px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
